import React from 'react'
import { Channel, FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { ValuesChangedTuple } from '../hocs/types'
import { ENewFilterRangeDesktop } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'
import { decodeFinanceOption, getDefaultFinanceOptions } from '@at/finance-utils'
import { SearchFiltersToggle } from '../../components/search-filters-toggle/search-filters-toggle'

const PriceMin = withFilterContext(FilterName.min_price, SearchFiltersDropdown, {
    title: ENewFilterRangeDesktop.MIN,
    ariaLabel: ariaLabel.price.min,
})
const PriceMax = withFilterContext(FilterName.max_price, SearchFiltersDropdown, {
    title: ENewFilterRangeDesktop.MAX,
    ariaLabel: ariaLabel.price.max,
})

export const Price = withFacetContext(FacetName.price, () => (
    <>
        <PriceMin title={ENewFilterRangeDesktop.MIN} />
        <PriceMax title={ENewFilterRangeDesktop.MAX} />
    </>
))

const NewPriceToggleHOC = withFacetContext(
    FacetName.price_search_type,
    withFilterContext(FilterName.price_search_type, SearchFiltersToggle, {
        title: '',
        defaultSelected: true,
    })
)

export const NewPriceToggle = ({ defaultFinanceValues }: DefaultFinanceValuesProps) => {
    const onValueChanged = (valueClicked: string[]) => {
        if (valueClicked[0] === 'total') {
            return [
                ['total'],
                [
                    { filter: FilterName.min_price, selected: [] },
                    { filter: FilterName.max_price, selected: [] },
                    { filter: FilterName.min_monthly_price, selected: [] },
                    { filter: FilterName.max_monthly_price, selected: [] },
                    { filter: FilterName.deposit, selected: [] },
                    { filter: FilterName.term, selected: [] },
                    { filter: FilterName.yearly_mileage, selected: [] },
                ],
            ] as ValuesChangedTuple
        } else {
            return [
                ['monthly'],
                [
                    { filter: FilterName.min_price, selected: [] },
                    { filter: FilterName.max_price, selected: [] },
                    { filter: FilterName.min_monthly_price, selected: [] },
                    { filter: FilterName.max_monthly_price, selected: [] },
                    { filter: FilterName.deposit, selected: [defaultFinanceValues.deposit] },
                    { filter: FilterName.term, selected: [defaultFinanceValues.term] },
                    {
                        filter: FilterName.yearly_mileage,
                        selected: [defaultFinanceValues.yearly_mileage],
                    },
                ],
            ] as ValuesChangedTuple
        }
    }

    return <NewPriceToggleHOC onValueChanged={onValueChanged} />
}
interface DefaultFinanceValuesProps {
    defaultFinanceValues: DefaultFinanceValues
}

interface DefaultFinanceValues {
    deposit: string | null
    term: string | null
    yearly_mileage: string | null
}

export const getFinanceDefaults = (channel: Channel): DefaultFinanceValues => {
    const financeDefaults = getDefaultFinanceOptions(channel)
    const { mileage, deposit, term } = decodeFinanceOption(financeDefaults.value)
    return {
        deposit,
        term,
        yearly_mileage: mileage,
    }
}
